module.exports = __webpack_public_path__ + "img/icon_message.01031aed.svg";